import type { AppNotificationContextValue } from "./app-notification.type";

import { createContext, useContext } from "react";

const config = {
  contextName: "AppNotificationContext",
  providerName: "AppNotificationProvider",
};

export const AppNotificationContext =
  createContext<AppNotificationContextValue | null>(null);

export const useAppNotificationContext = () => {
  const contextValue = useContext(AppNotificationContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
